import React, { useState, useEffect, useCallback, useRef } from 'react';
import Modal from "react-bootstrap/Modal";
import ReactToPrint from 'react-to-print';
import ThongKeApi from "service/ThongKe/ThongKeApi";
import { PhieuIn } from './PhieuIn';
import { pushNotification } from 'utils/notifications';
import { formatNumber2 } from '../../../../utils/currencyFormat';
import { getDate } from '../../../../utils/formatDate';
import ReactDropdown from 'react-dropdown';
const ALL_PRINT_TEMPLATES = [
    { Keyword: 'MAUPHIEUTHU', ContractName: 'Phiếu Thu (A4)' },
    { Keyword: 'MAUPHIEUTHUA5', ContractName: 'Phiếu Thu (A5)' }
];
export const ModalIn = ({ show, onHide, thuChiId, type }) => {
    const [detailData, setDetailData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [templates, setTemplates] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState('');
    const [htmlToPrint, setHtmlToPrint] = useState('');
    const componentToPrintRef = useRef();

    useEffect(() => {
        if (show) {
            setLoading(true);
            setTemplates(ALL_PRINT_TEMPLATES);
            if (ALL_PRINT_TEMPLATES.length > 0) {
                setSelectedTemplate(ALL_PRINT_TEMPLATES[0].Keyword);
            } else {
                setSelectedTemplate('');
            }
            ThongKeApi.getDetailForModal(thuChiId)
                .then(detailRes => {
                    if (detailRes.status === 200 && detailRes.data) {
                        setDetailData(detailRes.data);
                    }
                })
                .catch(() => pushNotification("Lỗi khi tải dữ liệu.", "error"))
                .finally(() => setLoading(false));
        }
    }, [show, thuChiId])

    const handleBeforePrint = useCallback(() => {
        return new Promise((resolve) => {
            if (!selectedTemplate) {
                pushNotification("Vui lòng chọn mẫu in.", "warning");
                resolve(false);
                return;
            }
            ThongKeApi.getPrintPreview(thuChiId, selectedTemplate)
                .then(res => {
                    if (res.status === 200 && res.data) {
                        setHtmlToPrint(res.data);
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                })
                .catch(error => { 
                    console.error("Lỗi khi lấy dữ liệu in:", error);
                    pushNotification("Có lỗi xảy ra khi lấy dữ liệu in.", "error");
                    resolve(false); 
                });
        });
    }, [thuChiId, selectedTemplate]);

    const renderDetailContent = () => {
        if (loading) return <p>Đang tải chi tiết...</p>;
        if (!detailData) return <p>Không có dữ liệu.</p>;

        const lowerType = type.toLowerCase();
        const commonFields = (
            <>
                <p><strong>Người nộp:</strong> {detailData[0].NguoiNop}</p>
                <p><strong>Số tiền thực thu:</strong> {formatNumber2(detailData[0].SoTienThucThu)}</p>
                <p><strong>Ngày thu:</strong> {getDate(detailData[0].NgayThuChi)}</p>
                <p><strong>Người tạo:</strong> {detailData[0].NguoiTao}</p>
                <p><strong>Người thu:</strong> {detailData[0].NguoiThu}</p>
                <p><strong>Ghi chú:</strong> {detailData[0].GhiChu}</p>
                <p><strong>Nội dung:</strong> {detailData[0].NoiDung}</p>
            </>
        );

        const contractFields = (
            <>
                <p><strong>Mã hợp đồng:</strong> {detailData[0].MaHopDong}</p>
                <p><strong>Ngày vay:</strong> {getDate(detailData[0].NgayVay)}</p>
                <p><strong>Tiền vay:</strong> {formatNumber2(detailData[0].TienVay)}</p>
                <p><strong>Tên khách hàng:</strong> {detailData[0].TenKhachHang}</p>
                <p><strong>Ngày sinh:</strong> {getDate(detailData[0].NgaySinh)}</p>
                <p><strong>Địa chỉ:</strong> {detailData[0].DiaChi}</p>
            </>
        );
        const feeFields = (
            <>
                <p><strong>Phí kho:</strong> {formatNumber2(detailData[0].PhiKho)}</p>
                <p><strong>Phí khác:</strong> {formatNumber2(detailData[0].PhiKhac)}</p>
            </>
        );

        const penaltyFields = (
            <>
                <p><strong>Phí Phạt Đóng Lãi:</strong> {formatNumber2(detailData[0].PhiPhatDongLai)}</p>
                <p><strong>Phạt chậm đóng lãi:</strong> {formatNumber2(detailData[0].PhiDongLaiCham)}</p>
                <p><strong>Phạt tất toán sớm:</strong> {formatNumber2(detailData[0].PhatThanhToanSom)}</p>
                <p><strong>Phạt thanh toán quá hạn:</strong> {formatNumber2(detailData[0].PhatThanhToanQuaHan)}</p>
            </>
        );

        switch (lowerType) {
            case "ngoaile":
                return commonFields;
            case "goc":
            case "lai":
            case "phihangky":
                return <>{commonFields}{contractFields}{feeFields}</>;
            case "khac":
            case "phiphat":
                return <>{commonFields}{contractFields}{feeFields}{penaltyFields}</>;
            default:
                return <p>Loại chi tiết không xác định.</p>;
        }
    };
    const dropdownOptions = templates.map(t => ({
        value: t.Keyword,
        label: t.ContractName
    }));
    return (
        <>
            <Modal show={show} onHide={onHide} size="lg" centered className='modal-new modal fade text-left'>
                <Modal.Header >
                    <h4 className="modal-title color7-bold ml-1 mt-1">Chi Tiết Giao Dịch</h4>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <ReactDropdown
                            options={dropdownOptions}
                            onChange={(option) => setSelectedTemplate(option.value)}
                            value={selectedTemplate}
                            placeholder="Chọn mẫu in..."
                            disabled={templates.length === 0}
                            controlClassName="form-control input-sm"
                        />
                        <button
                            type="button"
                            className="close-popup-new mb-1"
                            onClick={onHide}
                        >
                            <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                        </button>
                    </div>

                </Modal.Header>
                <Modal.Body>
                    {renderDetailContent()}

                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-100 justify-content-end align-items-center">
                        <div>
                            <button className="btn btn-new-main btn-closenew" onClick={onHide}>Đóng</button>
                            <ReactToPrint
                                trigger={() => <button className="btn btn-new-main button-popup-submit">In Phiếu</button>}
                                content={() => componentToPrintRef.current}
                                onBeforeGetContent={handleBeforePrint}
                                copyStyles={false}
                            />
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>

            <div style={{ display: "none" }}>
                <PhieuIn ref={componentToPrintRef} htmlContent={htmlToPrint} />
            </div>
        </>
    );
};